import { Link } from "@StarberryUtils";
import React from "react";
import {Col, Row, Tab, Nav, Container } from 'react-bootstrap';
import ModalTiny from "react-bootstrap/Modal"
import  "./Calculator.scss";
// import profImg3 from "../../../images/profile-img03.png"
import { useStaticQuery, graphql } from "gatsby";
import MortgageCalc from '../../calculators/mortgagecalc/';
import StampdutyCalc from '../../calculators/stampdutycalc/';
import RentalYield from '../../calculators/rentalyieldcalc/';
import ContactForm from "../../forms/reach-us-form"

import { inViewOptions } from '../../../components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}
const item = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}
const MotionCol = motion(Col)

const Calculator=(props)=>{

  const data = useStaticQuery(graphql`
    query Calc{

      strapiSiteConfig {
        Mortgage_Advisor {
          Tile_Image {
            publicURL
          }
          Name
        }
      }

    }
  `);


    const [modalAskformOpen,setAskformOpen] = React.useState(false);
    const openAskformModal = () => {
      setAskformOpen(true);
    }
    const closeAskformModal = () => {
      setAskformOpen(false);
    }


  return(
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.div
          className="calculator-sec"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >

            {props.property_search_type === 'sales' &&
            <Container>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                    <Col sm={12}>
                    <Nav variant="pills" >
                        <Nav.Item>
                        <Nav.Link eventKey="first">Mortgage Calculator</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="second">Stamp Duty Calculator</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    </Col>
                    <Col sm={12}>
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <motion.div
                            variants={item}
                          >
                            {/* <p className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lobortis at tortor sit amet euismod. </p> */}

                            <MortgageCalc propertyPrice={props.price} title={props.title}/>

                            {data.strapiSiteConfig.Mortgage_Advisor &&
                            <div className="d-md-flex mortgage-advisor-show">
                                <div className="profile-item d-flex align-items-center">
                                    <span className="profile-img">
                                        <img loading="lazy" src={data.strapiSiteConfig.Mortgage_Advisor.Tile_Image.publicURL} alt="Image"/>
                                    </span>
                                    <div className="info">
                                      <p className="pro-post d-lg-none"><Link to="#" onClick={openAskformModal}>Schedule an appointment </Link> with our Mortgage {data.strapiSiteConfig.Mortgage_Advisor.Name}.</p>
                                        <p className="pro-post d-none d-lg-block"><Link to="#" onClick={openAskformModal}>Book an appointment</Link> <span>with Mortgage {data.strapiSiteConfig.Mortgage_Advisor.Name}.</span> </p>
                                    </div>
                                
                                </div>


                              <ModalTiny backdrop="static" show={modalAskformOpen} onHide={closeAskformModal} className="book-a-viewing-modal people-details-form-modal-main">
                                <ModalTiny.Header closeButton className="contact-close-btn">
                                  <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Contact {data.strapiSiteConfig.Mortgage_Advisor.Name}</h2></ModalTiny.Title>
                                </ModalTiny.Header>
                                <ModalTiny.Body className="event-section people-details-form-modal"><ContactForm to_email_id={data.strapiSiteConfig.Mortgage_Advisor.Email}/></ModalTiny.Body>
                              </ModalTiny>


                            </div>
                            }
                          </motion.div>
                        </Tab.Pane>
                        <Tab.Pane className="tab-panel-2" eventKey="second">
                          <motion.div
                            variants={item}
                          >
                            {/* <p className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lobortis at tortor sit amet euismod. </p> */}

                            <StampdutyCalc propertyValue={props.price} propertyType="residential" buyerType="first" title={props.title}/>
                          </motion.div>
                        </Tab.Pane>
                    </Tab.Content>
                    </Col>
                </Row>
              </Tab.Container>
            </Container>
            }

            {props.property_search_type === 'lettings' &&
                <Container className="rentalyield">
                    <Row>
                        <MotionCol
                          sm={12}
                          md={6}
                          variants={item}
                        >
                          <h3>Rental Yield Calculator</h3>
                          {/* <p className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lobortis at tortor sit amet euismod. </p> */}

                          <RentalYield propertyPrice={props.price} monthlyRent="1000" title={props.title}/>
                        </MotionCol>
                    </Row>
                </Container>
            }


        </motion.div>
      )}
    </InView>
  )
}

export default Calculator